import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import { getTokenApi, getPACHistory } from 'store/user/apis';
import { REQUESTS_STATUSES } from 'constants/amcStatuses';
import { StyledtBlocWrapper } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/styles';
import {
  StyledTabs,
  StyledTab,
} from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests/styles';
import Requests from 'components/PACRequests';
import { translate } from 'helpers/intl';
import moment from 'moment';
import _ from 'lodash';
import { Box, CircularProgress } from '@material-ui/core';
import {
  StyledCard,
  StyledGrid,
} from 'containers/AUTODashboard/Body/LastSinister/styles';
import ItemEmptyState from 'components/ItemEmptyState';
import messages from './messages';

function a11yProps(index: number) {
  return {
    id: `my-contracts-tab-${index}`,
    'aria-controls': `my-contracts-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
}
export interface listPACType {
  date: string;
  Statut: string;
  Reference: string;
  IdCategorie: string;
  DateCreation: string;
  NomPrenomPAC: string;
  DateNaissance: string;
  DateNaissanceFormatted: string;
  Genre: string;
  MotifRejet: string;
  LibelleCategorie: string;
  DateDemande: string;
  ReferenceDemande: string;
  LibelleMotifRejet: string;
}

export interface PACType {
  [key: string]: listPACType[];
}

const MyRequests = ({
  ...props
}: {
  intl: IntlShape;
  selectedOrganisme?: any;
}) => {
  const [expandeds, setExpanded] = useState<boolean | String>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [listDossier, setListDossiers] = useState<PACType>({});
  const [unfiltredListDossier, setUnfiltredListDossiers] = useState<
    listPACType[]
  >([]);
  const [value, setValue] = React.useState(0);
  const handleChange = (index: String, claimNumber: String) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    setExpanded(isExpanded ? index : false);
  };

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    // eslint-disable-next-line
    setValue(newValue);
  };

  const token = localStorage.getItem('token');
  /* istanbul ignore next */
  useEffect(() => {
    setLoading(true);
    getTokenApi({
      identifiant: props.selectedOrganisme?.id,
      token: token ? token : '',
      username: props.selectedOrganisme?.NUM_POLICE,
    })
      .then((result) => {
        const res = get(result, 'data', {});
        if (!isEmpty(res)) {
          const payload = {
            NumPolice: res?.numeroPolice,
            identifiant: res?.login,
            token: res?.access_token,
            sessionsId: res?.session_id,
          };

          getPACHistory(payload)
            .then((result) => {
              const res = get(result, 'data', {});
              setUnfiltredListDossiers(res);
              setLoading(false);
            })
            .catch(() => setLoading(false));
        }
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, props.selectedOrganisme]);

  const filterData = (data: listPACType[]) => {
    return _.groupBy(
      data.map(
        /* istanbul ignore next */ (e: listPACType) => ({
          date: e.DateDemande.split('-')[0],
          Statut: e.Statut,
          Reference: e.ReferenceDemande,
          IdCategorie: e.LibelleCategorie,
          DateCreation: moment(e.DateDemande).format('DD/MM/YYYY'),
          NomPrenomPAC: e.NomPrenomPAC,
          DateNaissance: e.DateNaissance,
          DateNaissanceFormatted: e.DateNaissanceFormatted,
          Genre: e.Genre,
          MotifRejet: e.LibelleMotifRejet,
        }),
      ),
      'date',
    ) as PACType;
  };

  useEffect(() => {
    const dossiers = filterData(unfiltredListDossier);
    setListDossiers(dossiers);
  }, [unfiltredListDossier]);

  const tabItems = [
    {
      label: translate({ ...messages.allRequests }, props),
    },
    {
      label: translate({ ...messages.createdRequests }, props),
    },
    {
      label: translate({ ...messages.validatedRequests }, props),
    },
    {
      label: translate({ ...messages.rejectedRequests }, props),
    },
  ];

  /* istanbul ignore next */
  const getListRquests = () => {
    switch (value) {
      case 1:
        return filterData(
          unfiltredListDossier.filter(
            (item) => item.Statut === REQUESTS_STATUSES.CREATED,
          ),
        );
      case 2:
        return filterData(
          unfiltredListDossier.filter(
            (item) => item.Statut === REQUESTS_STATUSES.VALIDATED,
          ),
        );
      case 3:
        return filterData(
          unfiltredListDossier.filter(
            (item) => item.Statut === REQUESTS_STATUSES.REJECTED,
          ),
        );
      default:
        return listDossier;
    }
  };

  return (
    <StyledtBlocWrapper height="auto">
      <StyledTabs
        value={value}
        onChange={handleChangeTab}
        aria-label="my contracts tabs"
        style={{ marginBottom: '20px' }}
      >
        {tabItems.map((tab: tabItemProps, index) => (
          <StyledTab
            key={index}
            label={tab.label}
            {...a11yProps(index)}
            disableRipple
          />
        ))}
      </StyledTabs>
      {isLoading ? (
        <Box
          style={{
            textAlign: 'center',
            marginTop: 42,
            marginBottom: 42,
          }}
        >
          <CircularProgress color="inherit" size={20} />
        </Box>
      ) : Object.keys(getListRquests()).length === 0 ? (
        <StyledCard>
          <StyledGrid
            container
            textAlign="center"
            alignItems="center"
            justify="center"
            marginBottom="17px"
          >
            <ItemEmptyState
              label={translate({ ...messages.emptyState }, props)}
            />
          </StyledGrid>
        </StyledCard>
      ) : (
        <Requests
          listIndex={0}
          isLoading={isLoading}
          requests={getListRquests()}
          expanded={expandeds}
          handleChange={
            /* istanbul ignore next */ (index: String, claimNumber: String) =>
              handleChange(index, claimNumber)
          }
        />
      )}
    </StyledtBlocWrapper>
  );
};
export default injectIntl(MyRequests);
